<template>
  <el-row class="wrap">
    <!--头部-->
    <el-col :span="24" style="text-align: center; padding-top: 60px">
      <!-- <h1>Not Found!  404! </h1> -->
      <img src="../assets/images/404.png" alt="" class="err" />
    </el-col>
  </el-row>
</template>
<style lang="less" scoped>
  .err {
    width: 50%;
    height: auto;
  }
</style>
